import { Inject, Injectable, LOCALE_ID } from '@angular/core';
import { StorageKeys } from '@core/storage/storage.keys';
import { DEFAULT_LANG } from '@shared/constants';


/**
 * Service for working with Locale
 */
@Injectable()
export class LocaleService {
    public static readonly _defaultSystemLocale: string = DEFAULT_LANG;

    #localeLang: string;

    public static getLocaleLang(): string {
        return LocaleService.detectLocale().toLowerCase();
    }

    public static detectLocale(): string {
        return localStorage.getItem(StorageKeys.SystemLocale) || this._defaultSystemLocale;
    }

    constructor(@Inject(LOCALE_ID) public systemLocale: string) {
        this.#localeLang = LocaleService.getLocaleLang();
    }

    public get lang(): string {
        return this.#localeLang;
    }
}
